import {Injectable} from '@angular/core';
import {Card, Edition} from '../core/entities/entities';
import {CardService} from './card.service';
import {isNullOrUndefined} from 'util';
import {HttpServiceBase, Page, PageRequest} from '../core/services/HttpServiceBase';
import {HttpService} from '../core/services/http.service';
import * as Rx from 'rxjs/Rx';
import {ResolverService} from '../core/services/resolver.service';
import {environment} from '../../environments/environment';
import {Observable} from 'rxjs/Observable';


export interface EditiontQuery {
  edition_name?: string;
  type?: number;
  code?: number;
  edition?: any;
  brandId?: number;
  wh_id?: any;
  disposizione?: string;
}

@Injectable()
export class EditionService  extends HttpServiceBase<Edition> {

  private _query: EditiontQuery;

  set query(query: EditiontQuery) {
    this.query;
    this._query = query;
    localStorage.setItem('EditionService.query', JSON.stringify(this._query));
  }

  get query() {
    if (isNullOrUndefined(this._query)) {
      const key_val = localStorage.getItem('EditionService.query');
      if (key_val) {
        this._query = JSON.parse(key_val);
        if (this._query.edition) {
          this._query.edition = this.fromJson(this._query.edition);
        }
      }

    }
    return this._query;
  }

  getUrl() {
    return 'autocomplete/cardset';
  }

  public getAllOrderByReleaseDateDesc(): Rx.Observable<Edition[]> {
    const me = this;
    return Rx.Observable.create((observer: any) => {
      me.httpCall('get',  this.getBasePath() + 'autocomplete/expansions' ).subscribe(ret =>  observer.next(me.fromJsonArray(ret || null)));
    });
  }


  public search(query: EditiontQuery): Rx.Observable<Edition[]> {

    const me = this;
    if (!isNullOrUndefined(environment.constants.minEditionAutocompleteLength)) {
      if (
        isNullOrUndefined(query) ||
        isNullOrUndefined(query.edition_name) ||
        query.edition_name.length < environment.constants.minEditionAutocompleteLength
      ){

        return Observable.from([[]]);

      }
    }


    return Rx.Observable.create((observer: any) => {
      ResolverService.instance().spinnerService.show();
      me.httpCall('get', me._url, {params: {set : query.edition_name, brandId: query.brandId }}).subscribe(ret => {observer.next(me.fromJsonArray(ret)); ResolverService.instance().spinnerService.hide(); });
    });
  }

  public getSet(query?: EditiontQuery):  Rx.Observable<Page<Card>> {
    const me = this;

    if (isNullOrUndefined(query)){
      query = me.query;
    }

    return Rx.Observable.create((observer: any) => {
        me.loadPage(undefined, <PageRequest>{pageSize: 5000}, this.getBasePath() + 'box/' +  query.code + '/' + query.type ).subscribe(ret => observer.next(ret));

      });
     /* me.httpCall('get', this.getBasePath() + 'box/'+  query.code + '/'+ query.type ).subscribe(ret => {
        observer.next( <Card[]> me.cardService.fromJsonArray(ret));
      });*/
  }

  public getSetNew(categoryId: number, brandId: number, expansionId: number, rarityId?: number):  Rx.Observable<Page<Card>> {
    const me = this;

    let path = `${categoryId}/${brandId}/${expansionId}`;

    if( rarityId){
      path = `${path}/${rarityId}`;
    }

    return Rx.Observable.create((observer: any) => {
      me.loadPage(undefined, <PageRequest>{pageSize: 5000}, this.getBasePath() + 'box/' + path ).subscribe(ret => observer.next(ret));

    });
    /* me.httpCall('get', this.getBasePath() + 'box/'+  query.code + '/'+ query.type ).subscribe(ret => {
       observer.next( <Card[]> me.cardService.fromJsonArray(ret));
     });*/
  }

  protected init(): void {
  }

  public getCleanInstance(): Edition {
    return new Edition();
  }

  constructor(protected http: HttpService, private cardService: CardService) {
    super(http);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/edition.service.ts